import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7297814b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=7297814b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7297814b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7297814b')) {
      api.createRecord('7297814b', component.options)
    } else {
      api.reload('7297814b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7297814b&scoped=true&", function () {
      api.rerender('7297814b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/usdtWithdraw/index.vue"
export default component.exports